// Client only
import React, { lazy, memo, Suspense, useEffect, useRef, useState } from "react"
import useDeepCompareEffect from 'use-deep-compare-effect'
import dayjs from 'dayjs'
import { trackEvent } from 'components/analytics'
import { dataStore, pageStore, filterStore, userStore } from "state/store-zustand";

// Hooks to get data and update global filter state
import useFilterHooks from 'components/filters/useFilterHooks'
const {
  activitiesToOptions,
  eventTags,
  isEventTag,
  getDatesFromRange,
  slugify
} = useFilterHooks()

import Logo from 'components/header/logo'
import BasicAutoComplete from 'components/search/AutoComplete/Basic'
import BasicSlider from "components/slider/basic"
import { Select, MenuItem, FormControl, InputLabel } from '@mui/material';

// TODO: move to com
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs';
import { DesktopDateRangePicker } from '@mui/x-date-pickers-pro/DesktopDateRangePicker';
import { MobileDateRangePicker } from '@mui/x-date-pickers-pro/MobileDateRangePicker';
import { DateRangeCalendar } from '@mui/x-date-pickers-pro/DateRangeCalendar';
import { LicenseInfo } from '@mui/x-license-pro';
const muiKey = (typeof process !== 'undefined' && process.env && process.env.GATSBY_MUI_KEY) || '94aff8dbf66c360d48e0b389b099c896Tz0xMDA5NDAsRT0xNzYxODY1OTYyMDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1pbml0aWFsLEtWPTI=';
LicenseInfo.setLicenseKey(muiKey);

import VibemapSearchProvider from 'components/utils/search-context/Provider'
import VibemapSearchField from 'components/search/Field'

//import { getRelatedVibes } from 'components/utils/getRelatedVibes'
import {
  getRelatedVibes,
  getVibeInfo,
  getVibes,
  getCategory,
  getCategoriesByLevel,
  getSubCategories,
  getVibesFromSlugs
} from 'vibemap-constants/dist/vibes.js'

import {
  //searchTags,
  //getDatesFromRange,
  sortByPopularity,
  suggestPlacesByName
} from 'vibemap-constants/dist/helpers'

import PillButton from 'components/elements/buttons/pill/pillButton'

import './filters.scss'

const Filters = React.memo(({
  overrideActivities = null,
  overrideVibes = null,
  multiSelect = false,
  size = 'base',
  showActivities = false,
  showAllButton = false,
  showAddButton = true,
  showCities = false,
  showDateCalendar = false,
  showEventSearch = false,
  showIcons = true,
  showScrollArea = false,
  showRelatedVibes = false,
  showAllLink = false,
  layout = 'default',
  ...props
}) => {

  // Get Global Context
  const {
    isClient,
    isMobile,
    themeClass,
    themeName,
    themeObject,
    pageCurrent
  } = pageStore((state) => state)

  const isEvents = pageCurrent.includes('events')
  const isLoggedIn = userStore((state) => state.isLoggedIn)
  const user = userStore((state) => state.user)

  const vibesAll = dataStore((state) => state.vibesAll)
  const vibesAllDetailed = dataStore((state) => state.vibesAllDetailed)
  const getActivityDetails = dataStore((state) => state.getActivityDetails)
  const getVibeDetails = dataStore((state) => state.getVibeDetails)

  const categoriesTop = filterStore((state) => state.categoriesTop)
  const showOnlyEventTags = filterStore((state) => state.showOnlyEventTags)
  const categoriesTopFlat = categoriesTop.flatMap(cat => {
    const cat_slug = cat[0]
    const cat_count = cat[1]
    return cat_slug
  })

  const addLinkFromTheme = themeObject && themeObject?.eventForm?.link
  const addEventLink = addLinkFromTheme ?
    addLinkFromTheme :
    `/add-event?theme=${themeName ? themeName : ''}`

  const {
    dateRangeCurrent,
    dateRangeStartEnd,
    dateStart,
    dateStartPicked,
    dateEnd,
    filters,
    hasFilters,
    hasVibesFilter,
    isApprovedFilter,
    locationsTop,
    numChipsToShow,
    showCats,
    showDateRange,
    showFilters,
    showFilterCount,
    showLocations,
    showSearch,
    showTags,
    showVibes,
    tagsTop,
    tagsTopCount,
    vibesAvailable,
    vibesCurrent,
    vibesTop,
    vibesTopCount,
    setActivitiesCurrent,
    setDateStart,
    setDateRangeCurrent,
    setDateRangeStartEnd,
    setDateEnd,
    setFilters,
    setHasFilters,
    setIsApprovedFilter,
    setSearchCurrent,
    setVibesAvailable,
    setTagsCurrent,
    setVibesCurrent,
    setVibesTop,
    setVibesRelated,
  } = filterStore((state) => state)

  const { events: eventsTheme } = themeClass || {}
  const { vibes: vibesToInclude } = eventsTheme || {}

  const initalActivity = props.activity
    ? props.activity
    : props?.filters?.activities && props?.filters?.activities.length > 0
      ? props.filters.activities[0]
      : null

  const [activity, setActivity] = useState(initalActivity)
  const [activityIndex, setActivityIndex] = useState(initalActivity)

  // Get categories from all
  const activities = initalActivity
    ? getSubCategories(initalActivity).sort(sortByPopularity)
    : getCategoriesByLevel(2)

  const [vibes, setVibes] = useState([])
  const [vibesShown, setVibesShown] = useState(20)

  const [vibeOptions, setVibeOptions] = useState([])
  const [activityOptions, setActivityOptions] = useState([])

  const [showCustomDate, setShowCustomDate] = useState(false)
  const [isCustom, setIsCustom] = useState(dateRangeCurrent == 'custom')


  const [dateRangeCustom, setDateRangeCustom] = React.useState([
    dateRangeStartEnd?.start,
    dateRangeStartEnd?.end
  ])

  // If start and end date are set, use them and setShowCustomDate
  useEffect(() => {
    if (dateStart && dateEnd) {
      if (!isMobile) setShowCustomDate(true)
      const dateRangeCustomNew = Array.from([dateStart, dateEnd])
      setDateRangeCustom(dateRangeCustomNew)
      setDateRangeStartEnd({
        start: dateStart,
        end: dateEnd
      })
      dateRangeStartEnd.start = dateStart
      dateRangeStartEnd.end = dateEnd
    }
  }, [dateStart, dateEnd])
  //console.log('DEBUG: datestart, dateEnd ', dateStart, dateEnd);


  // Sync custom date range with dropdown
  const [previousRange, setPreviousRange] = useState(dateRangeCurrent)
  const dateRangeStartEndDep = JSON.stringify(dateRangeStartEnd)
  useEffect(() => {
    const today = dayjs()
    const isStartDateDiff = dateStart && dayjs(dateStart).isAfter(today)
    const dateRangeStart = isStartDateDiff ? dateStart : today
    const dateRangeEnd = dateEnd ? dateEnd : today

    const isCustomRange = dateRangeCurrent == 'custom' && isStartDateDiff

    // TODO: is there ever a case where start of range is not today?
    // FIXME: Check if user set custom dates!
    if (!isCustomRange && userSetDateRange.current == false) {
      // If date range is custom, use previous range
      const date_range = dateRangeCurrent == 'custom' ? previousRange : dateRangeCurrent
      const is_custom = date_range == 'custom'
      const dateRangeStartEndNew = getDatesFromRange(date_range, dateRangeStart, dateRangeEnd, is_custom)
      setPreviousRange(date_range)

      const start = dateRangeStartEndNew?.start
      const end = dateRangeStartEndNew?.end

      if (isStartDateDiff && start.isValid()){
        setIsCustom(true)
        setDateStart(start)
      }
      //console.log('DEBUG: dateRangeStartEnd ', dateRangeStartEnd, start, dateStart);
      const dateRangeCustomNew = Array.from([start, end])
      setDateRangeCustom(dateRangeCustomNew)
    }
  }, [dateRangeStartEndDep, dateRangeCurrent])


  const dateRangeCustomDep = JSON.stringify(dateRangeCustom)
  useEffect(() => {
    if (dateRangeCustom && dateRangeCustom.length > 0) {
      const start = dateRangeCustom[0]
      const end = dateRangeCustom[1]

      if (start && start.isValid() && end && end.isValid()){
        setDateStart(start)
        setDateEnd(end)
      }

      const newFilters = start && end && isCustom
        ? {
          ...filters,
          dateStart: start,
          endDate: end,
          dateRange: 'custom'
        }
        : {
          ...filters,
          dateRange: dateRangeCurrent
        }

      setFilters(newFilters)
      //console.log('DEBUG: set start and end ', start, end, newFilters);
    }
  }, [dateRangeCustomDep])


  useEffect(() => {
    const testDate = false
    if (testDate) {
      const dateStart = dayjs().add(2, 'month')
      setDateStart(dateStart)
      setTimeout(() => {
        // Test by setting a new start date after one sec
        const newStartDate = dayjs().add(2, 'month')
        setDateStart(newStartDate)
      }, 2000);
    }
  }, [])


  const [categoryTopLevel, setCategoryTopLevel] = useState(null)
  const handleActivitySelect = (event) => {

    const setFilters = filterStore((state) => state.setFilters)

    //console.log('handleActivitySelect ', event)
    const id = event.key
    const activty = getActivityDetails(id)
    const slug = activty[0].slug

    trackEvent('picked_activity', 'Filters', slug)

    if (slug) {
      const new_filters = {
        activities: [slug],
        cities: filters.cities,
        vibes: filters.vibes,
        vibesets: filters.vibesets,
        category: filters.category,
      }

      setFilters(new_filters)
    }
  }


  const handleActivityChange = (e, value, level, alreadyActive = false) => {
    e.stopPropagation()
    e.preventDefault()
    const newValue = alreadyActive ? null : value
    setActivity(newValue)
    setActivitiesCurrent(newValue)
    if (level <= 2) {
      // Keep top level category in state
      setCategoryTopLevel(value)
    }

    const new_filters = {
      ...filters,
      activities: alreadyActive ? [] : [value],
    }

    trackEvent('picked_activity', 'Filters', value)
    setFilters(new_filters)
    if (props.onChange) props.onChange(new_filters)
  }


  const handleCategoryRemove = (e, value) => {
    console.log(`handleCategoryRemove `, value);
    const categoryDetails = getCategory(value)
    const hadSearchTerm = categoryDetails && categoryDetails.details.searchTerm
      ? categoryDetails.details.searchTerm
      : false

    const activitiesPrevious = categoryTopLevel && categoryTopLevel != value
      ? [categoryTopLevel]
      : []

    const new_filters = {
      ...filters,
      searchTerm: hadSearchTerm ? null : filters.searchTerm,
      activities: activitiesPrevious,
    }

    setFilters(new_filters)
    // TODO: Handle previous top level category
    setActivity(null)
    setActivitiesCurrent([])

    if (props.onChange) props.onChange(new_filters)
  }


  const handleVibeChange = async (value, alreadyActive = false) => {
    const vibeDetails = getVibeDetails(value)

    const hasSearchTerm = vibeDetails && vibeDetails.details.searchTerm
      ? vibeDetails.details.searchTerm
      : null

    const isMulti = props.multiSelect
    const newVibes = isMulti
      ? filters.vibes.concat([value])
      : [value]

    const new_filters = {
      ...filters,
      searchTerm: hasSearchTerm ? vibeDetails.details.searchTerm : null,
      vibes: newVibes,
    }
    setVibesCurrent(newVibes)
    trackEvent('picked_vibe', 'Filters', value)
    setFilters(new_filters)
    if (props.onChange) props.onChange(new_filters)
  }


  const handleCityChange = async (e, value, alreadyActive = false) => {
    const newCities = filters.cities.concat([value])
    console.log('handleCityChange ', value, newCities)
    /*
    const new_filters = {
      ...filters,
      cities: newCities
    }
    setFilters(new_filters)
    */
  }


  const handleTagChange = async (e, value, alreadyActive = false) => {
    e.stopPropagation()
    e.preventDefault()

    const isMulti = props.multiSelect
    const newTags = isMulti
      ? filters.tags.concat([value])
      : [value]

    setTagsCurrent(newTags)

    const new_filters = {
      ...filters,
      tags: newTags,
    }

    setFilters(new_filters)
  }


  const handleTagRemove = (e, value) => {
    const tags_removed = filters.tags.filter(tag => tag.includes(value) == false)
    const new_filters = {
      ...filters,
      tags: tags_removed
    }
    setFilters(new_filters)
  }


  const handleVibeRemove = (e, value) => {
    const vibeDetails = getVibeDetails(value)
    const hadSearchTerm = vibeDetails && vibeDetails.details.searchTerm
      ? vibeDetails.details.searchTerm
      : false

    const reduceVibes = filters.vibes.filter(vibe => vibe.includes(value) == false)
    const new_filters = {
      ...filters,
      searchTerm: hadSearchTerm ? null : filters.searchTerm,
      vibes: reduceVibes,
    }

    setVibesAvailable(resetVibes())
    setVibesCurrent([])
    setVibesTop([], true)

    setFilters(new_filters)
    if (props.onChange) props.onChange(new_filters)
  }


  const handleCityRemove = (e, value) => {
    const reduceCities = filters.cities.filter(city => city.includes(value) == false)
    const new_filters = {
      ...filters,
      cities: reduceCities,
    }
    setFilters(new_filters)
  }

  const handleDateRangeSelect = (event) => {
    const value = event?.target?.value

    const new_filters = Object.assign({}, filters)
    setDateRangeCurrent(value)
    setFilters(new_filters)

    const isCustom = value == 'custom'
    setShowCustomDate(isCustom)
    setIsCustom(isCustom)
    //setHasFilters(true)
  }


  // TODO: resetVibes is not the best name
  const resetVibes = () => {
    const allVibes = [...new Set(getVibes('all'))]
    const vibesToAllow = vibesToInclude
      ? allVibes.filter(vibe => vibesToInclude.includes(vibe?.slug))
      : allVibes.sort(sortByPopularity)

    const hasTopVibes = vibesTop && vibesTop.length > 0
    const vibesOrdered = hasTopVibes
      ? vibesTop.flatMap(vibe => {
        const slug = vibe[0]
        const vibeDetails = getVibeInfo(slug)

        const shouldInclude = vibesToInclude ? vibesToInclude.includes(slug) : true
        if (shouldInclude && vibeDetails) {
          return vibeDetails
        } else {
          //console.log('problem with vibe ', slug, vibeDetails);
          return []
        }

      })
      : vibesToAllow

    setVibesAvailable(vibesOrdered)
    return vibesOrdered
  }

  const handleSearchUpdate = (searchTerm) => {
    console.log('handleSearchUpdate ', searchTerm);
    if (searchTerm && searchTerm.length > 1) {
      setSearchCurrent(searchTerm)
      setHasFilters(true)
    } else {
      setSearchCurrent(null)
      setHasFilters(false)
    }
  }

  // ✨ ACTIVITIES: Initial side effect
  // ✨ Set default activity and vibe filters
  useEffect(() => {
    //console.log('DEBUG: activities ', props.overrideActivities, activities);
    const shouldSet = filters.activities.length == 0
    if (shouldSet) {
      const activityOptions = props.overrideActivities
        ? props.overrideActivities
        : activitiesToOptions(activities.sort(sortByPopularity))

      setActivityOptions(activityOptions)
    }

  }, [activity])


  // ✨ VIBES: Initial side effect
  // ✨ Set default activity and vibe filters
  const vibesDep = JSON.stringify(vibes)
  const vibesTopDep = JSON.stringify(vibesTop)
  const vibesAvailableDep = JSON.stringify(vibesAvailable)
  useEffect(() => {
    // Rebuilt vibe tree based on selected vibes and top vibes
    const vibesObject = resetVibes()

    const hasVibes = filters?.vibes?.length > 0 == true
    //console.log('DEBUG: vibesObject, hasVibes ', vibesObject, hasVibes);

    if (hasVibes == false) {
      const sortedVibeOptions = props.overrideVibes
        ? props.overrideVibes
        : activitiesToOptions(vibesObject)

      const optionsToShow = sortedVibeOptions.slice(0, vibesShown)
      setVibeOptions(optionsToShow)
    }
  }, [activity, vibesDep, vibesAvailableDep, vibesTopDep])


  // ✨ Filters side effects for Activity / Category
  // ✨ Update filters & context based on activity filter
  useDeepCompareEffect(() => {
    (async () => {
      // Set activity and get vibes
      // FIXME: activites are an array here but string in context
      if (filters.activities && filters.activities.length > 0) {

        // Current activity
        const activitySlug = filters.activities[0]
        const activityDetails = getCategory(activitySlug)
        setActivity(activitySlug)

        // Combine current with subs
        const categoriesCombined = [activityDetails]
        const subCategories = getSubCategories(activitySlug).sort(sortByPopularity)
        const combined = categoriesCombined.concat(subCategories)
        const subCategoryOptions = activitiesToOptions(combined)
        setActivityOptions(subCategoryOptions)

        // Get and show related vibes to activity
        if (activityDetails && activityDetails.details.vibes) {
          // Only array
          const activityVibes = activityDetails.details.vibes
            .map(vibe => typeof vibe == 'string' ? vibe : vibe.slug)

          const withRelated = getRelatedVibes(activityVibes)

          if (withRelated) {
            setVibes(activityVibes)
            //setVibesCurrent(activityVibes)
            setVibesRelated(withRelated)

            // Concat, unique only
            const vibesCombined = [...new Set([...activityVibes, ...withRelated])]
            const vibeOptionsCombined = activitiesToOptions(getVibesFromSlugs(vibesCombined))
            // FIXME: setting related causes zero results
            //setVibeOptions(vibeOptionsCombined)
          }
        }
        // Hook to sync filters with global context
        //context.setFilters(filters)
      }

      if (filters.vibes && filters.vibes.length > 0) {
        const withRelated = getRelatedVibes(filters.vibes)

        if (withRelated) {
          setVibesRelated(withRelated)
          setVibes(filters.vibes)
          setVibesCurrent(filters.vibes)
          //const vibesCombined = filters.vibes.concat(withRelated)
          const vibesCombined = [...new Set([...withRelated, ...filters.vibes])]
          const vibeOptionsCombined = activitiesToOptions(getVibesFromSlugs(vibesCombined))
          //setVibeOptions(vibeOptionsCombined)
        }
      }
    })()

  }, [filters, vibesAll, vibesAvailable])

  let cityCurrent = filters.cities.length > 0 && filters.cities[0]
  let slug = null
  const pageLink = cityCurrent
    ? `/cities/${cityCurrent}/${props.page}/${slug}`
    : `?activities=${slug}`


  let defaultValue = undefined
  const activitySelect = (
    <Suspense fallback={<div>Loading</div>}>
      <Select
        className='activityFilter'
        classNamePrefix={'react-select'}
        defaultValue={defaultValue}
        onChange={handleActivitySelect}
        isSearchable={!isMobile}
        menuIsOpen={true}
        placeholder='Activities'
        width={180}
        options={activityOptions} />
    </Suspense>
  )

  const showScrollButtons = !isMobile
  const scrollButtonSize = isMobile ? 28 : 32

  const PillColumn = memo(({
    className = 'vibes',
    children,
    useSlider = true,
    selected
  }) => {

    return (
      <div className="columns" key={className}>
        <div className={`column is-12 ${className}`}>
          <div className='filters'>
            {selected
              ? <div className='selected'>{selected}</div>
              : null
            }

            {useSlider
              ? <BasicSlider key={`${className}-slide`} sizeButton={scrollButtonSize} showScrollButtons={showScrollButtons}>{children}</BasicSlider>
              : <div className='pills' style={{ display: 'inline-flex', gap: '1rem', 'flex-wrap': 'wrap'}}>{children}</div>
            }

          </div>
        </div>
      </div>
    )
  })


  // Selected buttons
  const hasActivity = filters.activities && filters.activities.length > 0
  //console.log('DEBUG: hasActivity ', hasActivity, filters.activities);
  const selectedActivityButtons = hasActivity
    ? filters.activities.map(selectedActivity => {
      // TODO: Make a dynamic link to the page, depnding on location
      const selected = activityOptions.find(activity => activity.key === selectedActivity)
      if (selected) {
        const name = selected.label.replace('&amp;', '&')
        const level = selected?.level
        const showIcon = showIcons && level <= 2
        return (
          <PillButton
            name={name}
            icon={showIcon ? selected.key : null}
            key={selected.key}
            slug={selected.key}
            selected={selected}
            isSelected={true}
            onClickCallback={handleCategoryRemove}
            onCancelCallback={handleCategoryRemove}
            showRemove={true} />
        )
      }
    })
    : [].concat(showAllButton
        ? <PillButton name={'All'} slug='all' icon='all' selected={getCategory('all')} isSelected={true} />
        : []
      )

  // All categories and subcategories
  const handleActivityClick = (e) => {
    e.preventDefault()
    const isActive = (activity == slug)
    if (onClickCallback) onClickCallback(e, slug, isActive)
  }

  const activityButtons = activityOptions.map((option, index) => {
    const showEvents = false
    const isActive = activity == option.key
    const isSelected = option.key == 'all'

    if (isActive && index !== activityIndex) setActivityIndex(index)
    if (isActive) return null

    const name = option?.label
      ? option?.label.replace('&amp;', '&')
      : option?.name.replace('&amp;', '&')

    const level = option?.level
    const slug = option?.key
    const is_in_top = categoriesTopFlat.includes(slug)
    //console.log('DEBUG: slug, is_in_top ', slug, is_in_top);
    const showIcon = level <= 2

    if (is_in_top == false) return null

    if (slug == 'events' && showEvents == false) return null

    return (
      <PillButton
        slug={option.key}
        name={name}
        selected={option}
        icon={showIcon ? option.key : null}
        onClickCallback={(e) => handleActivityChange(e, option.key, level)}
        showIcon={showIcon} />
    )
  })

  const hasVibe = filters.vibes && filters.vibes.length > 0
  const selectedVibeButtons = hasVibe
    ? filters.vibes.map(selectedVibe => {
      // Find string or object
      const vibeFound = vibesAllDetailed.filter(vibe => vibe === selectedVibe || vibe.slug === selectedVibe)
      //console.log('DEBUG: hasVibe ', hasVibe, filters.vibes, vibeFound);

      if (vibeFound && vibeFound.length > 0) {
        const name = vibeFound.length > 0 && vibeFound[0].seo
          ? vibeFound[0].seo.focuskw
          : vibeFound[0].name

        return (
          <PillButton
            name={name}
            key={selectedVibe}
            icon={'bolt'}
            slug={selectedVibe}
            selected={vibeFound}
            isSelected={true}
            onClickCallback={handleVibeRemove}
            onCancelallback={handleVibeRemove}
            showRemove={true} />
        )
      }
    })
    : [].concat(
      <PillButton
        key={'all-vibes'}
        name={'All Vibes'}
        icon={'bolt'}
        slug={'all'}
        isSelected={true}
        showRemove={false} />
    )

  const vibeButtons = vibeOptions.map(option => {
    const isActive = filters.vibes && filters.vibes.includes(option.key)
    const path = window && window.location
      ? window.location.pathname
      : `/`

    const pageLink = `${path}/?${activity ? activity + '&' : ''}vibes=${option.key}`

    if (isActive) return null // Don't show here
    const name = option.label
    const count = vibesTopCount[option.key]

    return (
      <PillButton
        name={name}
        slug={option.key}
        count={showFilterCount ? count : undefined}
        onClickCallback={handleVibeChange.bind(this, option.key, isActive)}
      />
    )
  })

  // TODO: make include/exclude tags consistent
  const tagsByTheme = themeObject && themeObject?.map?.tagsToInclude
  const tagNames = themeObject && themeObject?.map?.tagNames
  const tagsToExclude = themeObject && themeObject?.filters?.tagsToExclude

  console.log('DEBUG: tagsByTheme ', tagsByTheme, tagsToExclude);

  const selectedTagButtons = filters.tags && filters.tags.length > 0
    ? filters.tags.map(selectedTag => {
      const tag = filters.tags.filter(tag => tag === selectedTag)

      if (isEvents && isEventTag(selectedTag) == false) return null

      if (tag && tag.length > 0) {
        const tagString = tag[0]
        const name = tagNames && tagNames[tagString] || tagString
        const slug = name.toLowerCase()

        return (
          <PillButton
            key={slug}
            name={name}
            icon={'tag'}
            slug={slug}
            isSelected={true}
            onClickCallback={e => handleTagRemove(e, tag)}
            onRemoveCallback={e => handleTagRemove(e, tag)}
            showRemove={true}
          />
        )
      }
    })

    : showAllButton
      ? [].concat(
        <PillButton
          key={'all-tags'}
          name={'All Tags'}
          icon={'tag'}
          slug={'all'}
          isSelected={true}
          onRemoveCallback={handleTagRemove}
          showRemove={false} />
      )
      : []


  const tagButtons = tagsTop
    ? tagsTop.slice(0).map(tag => {
      tag = tag[0]
      const slug = tag.toLowerCase()
      const count = tagsTopCount[tag]
      const name = tagNames && tagNames[tag] || tag

      const isActive = filters.tags && filters.tags.includes(tag)
      const isEventTag = eventTags.some(eventTag => {
        const isMatch = eventTag.toLowerCase() === tag.toLowerCase()
        //console.log('isMatch ', isMatch, tag, eventTag)
        return isMatch
      });

      const isTagIncludedInTheme = tagsByTheme ? tagsByTheme.includes(tag) : true;
      const isTagNotExcluded = tagsToExclude ? !tagsToExclude.includes(tag) : true;
      console.log('DEBUG: isTagIncludedInTheme, isTagNotExcluded ', name, isTagIncludedInTheme, isTagNotExcluded);

      const isShownInTheme = isTagIncludedInTheme && isTagNotExcluded;
      const excludeOtherTags = showOnlyEventTags && isEvents && isEventTag == false
      if (isActive || !isShownInTheme || excludeOtherTags == true) return null

      return (
        <PillButton
          key={slug}
          name={name}
          showIcon={showIcons}
          slug={slug}
          count={showFilterCount ? count : undefined}
          onClickCallback={e => handleTagChange(e, tag)}
        />
      )
    })
    : []


  const allLocations = <PillButton
    name={'Locations'}
    icon={'location'}
    slug={'all'}
    isSelected={true}
    showRemove={false} />

  const selectedLocationChip = filters.cities && filters.cities.length > 0
    ? filters.cities.map(city => {
      return <PillButton
        name={city}
        key={city}
        icon={'location'}
        onClickCallback={handleCityRemove}
        onCancelCallback={handleCityRemove}
        isSelected={true}
        showRemove={true} />
    })
    : [].concat(allLocations)

  const locationChips = locationsTop
    ? locationsTop.map(location => {
      const slug = slugify(location)
      const isActive = filters.cities && filters.cities.includes(slug)

      if (isActive) return null

      return <PillButton
        name={location}
        key={slug}
        onClickCallback={handleCityChange}
        slug={slug} />
    })
    : null

  const dateRangeOptions = [
    { key: 'all', label: 'Upcoming', value: 'quarter' },
    { key: 'day', label: 'Today', value: 'today' },
    { key: 'weekend', label: 'Weekend', value: 'weekend' },
    { key: 'next_week', label: 'Next Week', value: 'next_week' },
    { key: 'month', label: 'This Month', value: 'month' },
    { key: 'quarter', label: '3 Mos', value: 'quarter' },
    { key: 'half_year', label: '6 Mos', value: 'half_year' },
    { key: 'year', label: '1 Year', value: 'year' },
    { key: 'custom', label: 'Custom', value: 'custom' }
  ]

  const dateRangeSelect = (
    <Select
      value={dateRangeCurrent}
      label="When"
      className={'small rounded'}
      onChange={handleDateRangeSelect}>
      {dateRangeOptions.map(item => <MenuItem key={item.value} value={item.value}>{item.label}</MenuItem>)}
    </Select>
  )

  const userSetDateRange = useRef(false)

  const handleDateRangeCustom = (new_range) => {
    userSetDateRange.current = true

    const start = new_range[0]
    const end = new_range[1]

    // Date picker needs to be set for both
    if (end == null || start == null) {
      return
    }

    setDateStart(start)
    setDateEnd(end)

    const new_filters = {
      ...filters,
      ...(start !== null ? { dateStart: start } : {}),
      ...(end !== null ? { dateEnd: end } : {}),
      dateRange: 'custom'
    }

    setFilters(new_filters)
    // Make a clone of new_range
    const new_range_clone = Array.from(new_range)
    setDateRangeCustom(new_range_clone)
  }


  const DateRangeUI = (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      {isMobile
        ? <MobileDateRangePicker
            onChange={(new_range) => handleDateRangeCustom(new_range)}
            defaultValue={dateRangeCustom}
            sx={{ width: '100%', marginTop: '1rem' }}
            value={dateRangeCustom} />
        : <DesktopDateRangePicker
            onChange={(new_range) => handleDateRangeCustom(new_range)}
            defaultValue={dateRangeCustom}
            sx={{ marginTop: layout == 'columns' ? '1rem' : '0' }}
            value={dateRangeCustom} />
      }
      {showDateCalendar
        ? <>
          <DateRangeCalendar
            defaultValue={dateRangeCustom}
            defaultRangePosition={'start'}
            calendars={1}
            sx={{
              display: 'flex',
              flexDirection: 'column', /* This stacks the children vertically */
              alignItems: 'center' /* This centers the calendars if they don't span the full width */
            }} />
          </>
        : null
      }
    </LocalizationProvider>
  )


  // TODO: Memoize?
  // Make options from event results
  const getSuggestions = async (val = '') => {
    const latitude = cityCurrent && cityCurrent.latitude
      ? cityCurrent.latitude
      : null
    const longitude = cityCurrent && cityCurrent.longitude
      ? cityCurrent.longitude
      : null

    const suggestions = await suggestPlacesByName(
      val,
      undefined,
      undefined,
      latitude,
      longitude,
      undefined,
      'events'
    )

    console.log('getSuggestions ', suggestions);
  }

  // Handle the isApprovedFilter state based on the selected value
  const handleIsApprovedFilter = (event) => {
    setIsApprovedFilter(
      event.target.value === 'all' ? undefined : // All
      event.target.value === 'pending' ? null : // Pending
      event.target.value === 'approved' ? true : // Approved
      false // Unapproved
    );
  };


  const EventSearch = (
    <BasicAutoComplete
      width={200}
      onTextChange={(e, val) => {
        handleSearchUpdate(val)
        getSuggestions(val)
      }} />
  )

  const AddEvent = (
    <a
      className={`add-event button small is-primary`}
      href={addEventLink}
      style={{
        marginBottom: 0,
        padding: '1rem 2rem',
      }}
      target='_blank'>
      Add Event
    </a>
  )

  const ApprovalFilter = isLoggedIn
      ? (
        <Select
          labelId="filter-label"
          className={'small rounded'}
          defaultValue={'approved'}
          label="Approval Status"
          value={
            isApprovedFilter === true
              ? 'approved'
              : isApprovedFilter === false
                ? 'unapproved'
                : 'pending'
          }
          onChange={handleIsApprovedFilter}
          size='small'
          width={180} >
            <MenuItem value="all">All</MenuItem>
            <MenuItem value="pending">Pending</MenuItem>
            <MenuItem value="approved">Approved</MenuItem>
            <MenuItem value="unapproved">Unapproved</MenuItem>
        </Select>
      )
      : null

  const handleSubmit = (e)  => {
    console.log('DEBUG handleSubmit ', e);
    e.preventDefault()
    return false
  }

  // Only show on client and when filters are enabled
  if (showFilters == false || isClient != true) return null

  const filterBarClass = `filter-bar ${size ? size : ''} ${props?.position ? props.position : ''}`
  const filterBarStyle = showScrollArea
    ? {
      paddingTop: '0.4rem',
      background: 'linear-gradient(to bottom, white 70%, transparent)'
    }
    : {}


  const showMobileSearchOnly = isMobile && showEventSearch && !showDateRange

  const AddButtonContainerStyle = {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'right',
    marginRight: '4rem',
  }

  const searchAddStyle = {
    display: 'flex',
    flex: 1,
    justifyContent: showMobileSearchOnly ? 'flex-start' : 'flex-end',
    marginBottom: '1rem',
    maxHeight: '4rem'
  }

  const styleMobileSearch = {
    display: 'flex',
    flex: 1,
    justifyContent: 'flex-start',
    marginBottom: '1rem'
  }

  const usePillSlider = pageCurrent != 'events' && layout != 'columns'

  return (
    <div key={filterBarClass} className={filterBarClass} style={filterBarStyle}>
      {showScrollArea
        ? <Logo full={true} width={60} newWindow={true} />
        : null
      }

      <div style={searchAddStyle}>
        {showMobileSearchOnly
          ? <div
              className='search-container'
              style={styleMobileSearch}>
              {EventSearch}
            </div>
          : null
        }

        {isMobile && isEvents && showAddButton ?
          <div style={ AddButtonContainerStyle }>
            {ApprovalFilter}
            {AddEvent}
          </div>
        : null
        }
      </div>

      {isClient &&
        <form onSubmit={handleSubmit}>
          <div className="column date">
            {(props.showCities || showDateRange) &&
              <div className="column is-12">
                <div className='filters row-1'>

                  {showEventSearch
                    ? EventSearch
                    : null
                  }

                  {showDateRange && dateRangeSelect}

                  {showDateRange // From UI or URL param
                    ? DateRangeUI
                    : null
                  }

                  {!isMobile
                    ? (
                      <div className='align-right' style={{
                        alignItems: 'center',
                        display: 'flex',
                        flexGrow: 1,
                        gap: '1rem',
                        justifyContent: 'flex-end',
                        paddingRight: isLoggedIn ? '4rem' : '2rem',
                        position: layout == 'columns' ? 'absolute' : 'relative',
                        top: layout == 'columns' ? '1rem' : 'auto',
                        right: layout == 'columns' ? '4rem' : 'auto',
                      }}>
                        {ApprovalFilter}
                        {AddEvent}
                      </div>
                    )
                    : null
                  }

                </div>
              </div>
            }

            {showSearch && props.showSearch
              ? <VibemapSearchProvider
                  //doAutoSearch
                  //storedCities={data.allWpCity.nodes}
                  //preferStoredCities
                  showGuides={false}
                  shouldUpdateURL={false}>
                  <VibemapSearchField
                    doSearchEvents={false}
                    doSearchGuides={false}
                    //onClick={handleClick}
                    onInputChange={handleSearchUpdate}
                    //initialSearch={venue}
                    placeholder={`Search by name, vibe, etc.`}
                    shouldClearForm={true}
                    showCities={false}
                    showGuides={false}
                    searchGeocoder={false} />
                </VibemapSearchProvider>
              : null
            }

            {showCats
              ? <PillColumn
                  className='activities'
                  key='activities'
                  selected={selectedActivityButtons}>
                  {activityButtons}
                </PillColumn>
              : null
            }


            {props.showAllLink &&
              <div className="column secondary is-6">
                <a href='/features/'>All Stories</a>
              </div>
            }
          </div>

          {showVibes
            ? <PillColumn
                className='vibes'
                selected={selectedVibeButtons}>
                {vibeButtons}
              </PillColumn>
            : null
          }

          {showTags
            ? <PillColumn
                className={`tags${layout == 'columns' ? ' inline' : ''}`}
                selected={selectedTagButtons}
                useSlider={usePillSlider}>
                {tagButtons}
              </PillColumn>
            : null
          }

          {showLocations
            ?
            <PillColumn
              className='locations'
              selected={selectedLocationChip}>
              {locationChips}
            </PillColumn>
            : null
          }

        </form>
      }
    </div>
  )
})


//Filters.whyDidYouRender = true
export default Filters